(() => {
  const STORAGE_KEY = 'lo_chat_conversation_id';
  const FIRST_MESSAGE_KEY = 'lo_chat_first_message_sent';
  const HISTORY_KEY = 'lo_chat_conversation_history';
  const LAUNCHER_SHOW_DELAY_MS = 3000;

  function getConversationId() {
    let id = sessionStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random();
      sessionStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  }

  function isFirstMessage() {
    return sessionStorage.getItem(FIRST_MESSAGE_KEY) !== 'true';
  }

  function markFirstMessageSent() {
    sessionStorage.setItem(FIRST_MESSAGE_KEY, 'true');
  }

  function getHistory() {
    try {
      return JSON.parse(sessionStorage.getItem(HISTORY_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function appendToHistory(role, message) {
    const history = getHistory();
    history.push({ role: role, message: message, timestamp: new Date().toISOString() });
    sessionStorage.setItem(HISTORY_KEY, JSON.stringify(history));
    return history;
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function linkifyUrls(escapedText) {
    const urlPattern = /(https?:\/\/[^\s<]+)/g;
    return escapedText.replace(urlPattern, function (url) {
      return '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + url + '</a>';
    });
  }

  function initWidget(root) {
    if (!root || root.dataset.initialised === 'true') return;
    root.dataset.initialised = 'true';

    const sectionId = root.dataset.sectionId;
    const settings = (window.loChatSettings && window.loChatSettings[sectionId]) || {};
    const webhookUrl = settings.webhookUrl;

    const launcher = root.querySelector('[data-lo-chat-launcher]');
    const chatWindow = root.querySelector('[data-lo-chat-window]');
    const closeButton = root.querySelector('[data-lo-chat-close]');
    const messages = root.querySelector('[data-lo-chat-messages]');
    const form = root.querySelector('[data-lo-chat-form]');
    const input = form.querySelector('.lo-chat__input');
    const sendButton = form.querySelector('.lo-chat__send');

    // Launcher is hidden by default via CSS (no display:flex until this
    // class is added), so there's no flash-of-icon on page load. It only
    // appears once, after the delay below, and only if the chat window
    // hasn't already been opened another way.
    setTimeout(() => {
      if (chatWindow.hidden) launcher.classList.add('lo-chat__launcher--visible');
    }, LAUNCHER_SHOW_DELAY_MS);

    const openWindow = () => {
      chatWindow.hidden = false;
      launcher.classList.remove('lo-chat__launcher--visible');
      setTimeout(() => input.focus(), 50);
    };

    const closeWindow = () => {
      chatWindow.hidden = true;
      launcher.classList.add('lo-chat__launcher--visible');
    };

    launcher.addEventListener('click', openWindow);
    closeButton.addEventListener('click', closeWindow);

    const appendMessage = (text, role) => {
      const el = document.createElement('div');
      el.className = 'lo-chat__message lo-chat__message--' + role;
      if (role === 'bot') {
        el.innerHTML = linkifyUrls(escapeHtml(text));
      } else {
        el.textContent = text;
      }
      messages.appendChild(el);
      messages.scrollTop = messages.scrollHeight;
      return el;
    };

    const appendTyping = () => {
      const el = document.createElement('div');
      el.className = 'lo-chat__message lo-chat__message--typing';
      el.textContent = 'Boogie is typing...';
      messages.appendChild(el);
      messages.scrollTop = messages.scrollHeight;
      return el;
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const text = input.value.trim();
      if (!text) return;

      if (!webhookUrl || webhookUrl.indexOf('REPLACE_WITH_CHAT_WEBHOOK') !== -1) {
        appendMessage('This chat isn\'t connected yet — check back soon.', 'bot');
        return;
      }

      appendMessage(text, 'user');
      input.value = '';
      sendButton.disabled = true;

      const firstMessage = isFirstMessage();
      const conversationHistory = appendToHistory('customer', text);
      const payload = {
        message: text,
        conversation_id: getConversationId(),
        is_first_message: firstMessage,
        page_url: window.location.href,
        submitted_at: new Date().toISOString(),
        source: 'lo-chat-widget',
        conversation_history: conversationHistory
      };

      const typingEl = appendTyping();

      fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then((response) => {
          if (!response.ok) throw new Error('Webhook responded with ' + response.status);
          return response.json();
        })
        .then((data) => {
          typingEl.remove();
          const replyText = (data && data.reply) || 'Sorry, I didn\'t catch that — could you try again?';
          appendMessage(replyText, 'bot');
          appendToHistory('assistant', replyText);
       if (firstMessage) {
            markFirstMessageSent();
            // OSC: count each new chat conversation as chat_enquiry in GA4
            if (typeof gtag === 'function') gtag('event', 'chat_enquiry');
          }
        })
        .catch(() => {
          typingEl.remove();
          appendMessage('Sorry, something went wrong. Please try again in a moment.', 'bot');
        })
        .finally(() => {
          sendButton.disabled = false;
        });
    });
  }

  document.querySelectorAll('.lo-chat').forEach(initWidget);

  // Support sections loaded later (e.g. theme editor re-renders)
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector && event.target.querySelector('.lo-chat');
    if (root) initWidget(root);
  });
})();
